export function installSwNavigateListener(navigate: (url: string) => void): () => void {
  const sw = (navigator as any).serviceWorker;
  if (!sw || !sw.addEventListener) {
    return () => {};
  }
  function onMessage(e: MessageEvent) {
    const data = (e && (e as any).data) || {};
    if (data && data.type === 'navigate' && typeof data.url === 'string') {
      // Always notify app of navigate intent so views can refresh/scroll even if already on the route
      try {
        window.dispatchEvent(new CustomEvent('headedout:navigate', { detail: { url: data.url } }));
      } catch {
        // ignore
      }
      navigate(data.url);
    }
  }
  sw.addEventListener('message', onMessage);
  return () => {
    try {
      sw.removeEventListener('message', onMessage);
    } catch {
      // ignore
    }
  };
}

